import { createContext } from 'react';

export interface AuthState {
  username: string | null;
  isAuthenticated: boolean;
  signIn: (username: string, password: string) => Promise<void>;
  signOut: () => void;
}

/**
 * The context lives apart from the provider component: a file exporting both a
 * component and a value loses Vite's fast refresh, and the provider is the file
 * most often edited while the app is running.
 */
export const AuthContext = createContext<AuthState | null>(null);
